'use strict';

import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { downloadApiMinApi } from '@/api/otherSources';

/**
 * 區間硬上限（天）。後端也擋一次 —— 這裡擋是為了不用等一趟往返就給回饋。
 *
 * 真正的量的上限在**後端**（伺服器記憶體，格子數預算），超過會回 400 帶訊息，
 * 直接顯示給使用者。見 docs/adr/0007-rawdata-download-cell-budget.md。
 */
var MAX_DAYS = 7;

/** 含頭含尾的天數 */
var daysBetween = function daysBetween(from, to) {
  return Math.round(DateTime.fromISO(to).diff(DateTime.fromISO(from), 'days').days) + 1;
};

/**
 * 下載每分鐘資料 xlsx。後端直接把檔案串回來，這裡只負責存檔。
 * @param {object} body { provider, plantNo, from, to, devices, realOnly }
 * @param {string} fileName 存檔用的檔名（不含副檔名）
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
var apiMinDownload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(body, fileName) {
    var _result, _result$data;
    var result, _err$response, blob, _JSON$parse, url, link;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return downloadApiMinApi(body);
          case 3:
            result = _context.sent;
            _context.next = 33;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.log('apiMinDownload failed', _context.t0);
            // responseType 是 blob，所以錯誤訊息也是 Blob —— 要讀成文字才看得到後端說什麼
            // （資料量過大、目前有人在下載，這些都要讓使用者看到，不能吞成「查無資料」）
            blob = _context.t0 instanceof Blob ? _context.t0 : _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
            _context.prev = 10;
            if (!(blob instanceof Blob)) {
              _context.next = 27;
              break;
            }
            _context.t2 = JSON;
            _context.next = 15;
            return blob.text();
          case 15:
            _context.t3 = _context.sent;
            _context.t4 = _JSON$parse = _context.t2.parse.call(_context.t2, _context.t3);
            _context.t1 = _context.t4 === null;
            if (_context.t1) {
              _context.next = 20;
              break;
            }
            _context.t1 = _JSON$parse === void 0;
          case 20:
            if (!_context.t1) {
              _context.next = 24;
              break;
            }
            _context.t5 = void 0;
            _context.next = 25;
            break;
          case 24:
            _context.t5 = _JSON$parse.msg;
          case 25:
            _context.t6 = _context.t5;
            return _context.abrupt("return", {
              ok: false,
              message: _context.t6
            });
          case 27:
            _context.next = 32;
            break;
          case 29:
            _context.prev = 29;
            _context.t7 = _context["catch"](10);
            console.log('parse error blob failed', _context.t7);
          case 32:
            return _context.abrupt("return", {
              ok: false
            });
          case 33:
            if ((_result = result) !== null && _result !== void 0 && (_result$data = _result.data) !== null && _result$data !== void 0 && _result$data.size) {
              _context.next = 35;
              break;
            }
            return _context.abrupt("return", {
              ok: false
            });
          case 35:
            url = window.URL.createObjectURL(result.data);
            link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "".concat(fileName, ".xlsx"));
            link.click();
            window.URL.revokeObjectURL(url);
            return _context.abrupt("return", {
              ok: true
            });
          case 42:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6], [10, 29]]);
  }));
  return function apiMinDownload(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export { apiMinDownload, daysBetween, MAX_DAYS };